import { render, staticRenderFns } from "./Sinistre.vue?vue&type=template&id=0ab5c1ef&"
import script from "./Sinistre.vue?vue&type=script&lang=js&"
export * from "./Sinistre.vue?vue&type=script&lang=js&"
import style0 from "./Sinistre.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports